import { RenewalStatus } from "@covertree/agent-portal-graphql";

export const mapRenewalStatus = (
  renewalStatus: RenewalStatus | null | undefined
) => {
  switch (renewalStatus) {
    case RenewalStatus.PaymentFailed:
      return "Payment Failed";
    case RenewalStatus.NonRenewalIssued:
      return "Non-Renewal Issued";
    case RenewalStatus.OfferSent:
      return "Offer Sent";
    case RenewalStatus.OfferSentFailed:
      return "Offer Sent Failed";
    case RenewalStatus.PricingFailed:
      return "Pricing Failed";
    case RenewalStatus.Issued:
      return "Issued";
    case RenewalStatus.UwAccepted:
      return "UW Accepted";
    case RenewalStatus.UwFailed:
      return "UW Failed";
    case RenewalStatus.UwReview:
      return "UW Review";
    case RenewalStatus.Upcoming:
      return "Upcoming";
    case RenewalStatus.Discarded:
      return "Discarded";
    case null:
    case undefined:
    case RenewalStatus.NotApplicable:
      return "N/A";
    default:
      return renewalStatus;
  }
};
